import i18n from '@/i18n';

const healthLogMetrics = {
  bloodPressure: i18n.t('Blood pressure'),
  oxygenSaturation: i18n.t('Oxygen saturation'),
  bloodSugar: i18n.t('Blood sugar'),
  bodyTemperature: i18n.t('Body temperature'),
  weight: i18n.t('Weight'),
  urine: i18n.t('Urine'),
} as Record<string, string>;

export default healthLogMetrics;
